export default {
  insertWlVehicleInfo: '/ygsjzs/wlVehicleInfo/insertWlVehicleInfo',
  updateWlVehicleInfo: '/ygsjzs/wlVehicleInfo/updateWlVehicleInfo',
  deleteDataWlVehicleInfo: '/ygsjzs/wlVehicleInfo/deleteDataWlVehicleInfo',
  selectWlVehicleInfoByVehicleId: '/ygsjzs/wlVehicleInfo/selectWlVehicleInfoByVehicleId',
  selectWlVehicleInfoByPage: '/ygsjzs/wlVehicleInfo/selectWlVehicleInfoByPage'
}
